import React, { useState, useRef, useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';

const ChatBar = ({ 
  currentSessionId,
  sessions,
  onSessionSelect, 
  onNewSession, 
  onDeleteSession,
  onRenameSession,
  isOpen,
  onClose 
}) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffTime = Math.abs(now - date);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays === 1) return 'Today';
    if (diffDays === 2) return 'Yesterday';
    if (diffDays <= 7) return `${diffDays} days ago`;
    return date.toISOString().split('T')[0];
  };

  return (
    <div className={`
      absolute inset-y-0 left-0 z-50 w-80 bg-gray-900 text-orange-300
      transform transition-transform duration-300 ease-in-out transform-none
      ${isOpen ? 'block' : 'hidden'}
    `}>
      <div className="flex flex-col h-full">
        {/* Header */}
        <div className="px-6 py-2 border-b border-gray-700 flex items-center justify-between">
          <button
            onClick={onClose}
            className="text-orange-400 hover:bg-gray-700 rounded"
          >
            <X className="w-6 h-6" />
          </button>
          <button
            onClick={() => {
              onNewSession();
              onClose();
            }}
            className="flex items-center space-x-2 text-orange-400 bg-gray-800 hover:bg-gray-700 px-4 py-2 rounded-lg transition-colors"
          >
            <MessageCircle className="w-4 h-4" />
            <span>New Chat</span>
          </button>
        </div>

        {/* Sessions List */}
        <div className="flex-1 overflow-y-auto p-2">
          <div className="space-y-1">
            {sessions?.map((session) => (
              <div
                key={session.id}
                onClick={() => {
                  onSessionSelect(session.id);
                  onClose();
                }}
                className={`group relative flex items-center p-3 rounded-lg cursor-pointer transition-colors ${
                  currentSessionId === session.id
                    ? 'bg-gray-700 text-white'
                    : 'hover:bg-gray-800 text-orange-300 hover:text-orange-400'
                }`}
              >
                <MessageCircle className="w-4 h-4 mr-3 flex-shrink-0" />
                <div className="flex-1 min-w-0">
                  <div className="font-medium text-sm truncate">
                    {session.title}
                  </div>
                  <div className="text-xs text-orange-200 mt-1">
                    {formatDate(session.updated_at)}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatBar;

